import React from "react";
import PropTypes from "prop-types";
import validate from "validate.js";
import validateHelper from "../../helpers/validate-helper";
import Alert from "../common/Alert";
import Connfirm from "../common/Confirm";
import jQuery from "jquery";
import Fa from "../common/Fa";
global.jQuery = jQuery;
global.jquery = jQuery;
global.$ = jQuery;

/**
 * Componente que corresponde a un form básico.
 */
export default class Form extends React.Component {
  confirm = {};
  alert = {};
  /**
   * @constructor
   * @param {*} props
   */
  constructor(props) {
    super(props);
    this.state = { test: 1 };
  }

  /**
   * Se encarga de setear la referencia de la instancia para manejar el
   * estado del componente mediante la función onRef.
   */
  componentDidMount() {
    this.props.onRef(this);
    this.$el = jQuery(this.el);
  }

  /**
   * Cunando se desmonta el componente se seta una referencia nula
   * al mismo.
   */
  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  /**
   * Se encarga de verificar si el objeto es valido según los criterios
   * definidos.
   * @param {object} recurso objeto a validar
   */
  isValid(recurso) {
    this.$el.find("[name]").each(function(e) {
      jQuery(this).trigger("validate");
    });
    const _valid = validate(recurso, this.props.validations);
    if (typeof _valid !== "undefined") {
      return false;
    }

    return true;
  }

  /**
   * renderiza el componente
   */
  render() {
    return (
      <form
        className={this.props.styleName}
        onChange={this.props.onChange}
        ref={el => (this.el = el)}
      >
        <div className="form-info">
          Los campos marcados con <Fa icon="asterisk" />
          son de obligatorios.
        </div>
        <Alert onRef={ref => (this.alert = ref)} />
        <Connfirm onRef={ref => (this.confirm = ref)} />
        {this.props.children}
      </form>
    );
  }
}

/**
 * Parametros del componente.
 *
 * @param {object} props
 * @param {string} props.styleName
 * @param {object} props.validations
 * @param {dom} props.children
 */
Form.propTypes = {
  styleName: PropTypes.string,
  validations: PropTypes.object,
  //children: PropTypes.arrayOf(PropTypes.element),
  onRef: PropTypes.func.isRequired
};

/**
 * Valores por defecto del componente
 */
Form.defaultProps = {
  styleName: "",
  validations: {}
};
